export default __webpack_public_path__ + "static/media/Catacomb Tunic.4a8a1ab6.jpg";